<template>
    <div v-if="store.isLoading">
      <vue-element-loading
        :active="store.isLoading"
        spinner="spinner"
        duration="1.5"
        color="#4f41a3"
        size="60"
      />
    </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'SearchLoading',
  inject: ['store'],
  components: {
    VueElementLoading
  },
}
</script>

<style scoped lang="scss">
  .velmld-parent {
      position: initial !important;
  }
</style>
